import gql from "graphql-tag";
const DeleteRunScreenerInputMutation = gql`
  mutation DeleteRunScreenerInput($objectId: ID!) {
    deleteRunScreenerInput(objectId: $objectId)
  }
`;
export default DeleteRunScreenerInputMutation;
